import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";

import {generateGuid} from "../../util/guid";
import Tooltip from "../common/Tooltip";
import * as types from "../../constants/ComponentConstants";
import ValidationMessage from "../common/ValidationMessage";
import Textarea from "react-textarea-autosize";
import Revert from "../common/Revert";

const TextAreaInput = (props) => {
	const hasValue = !!props.value;
	const hasValidationMessage = !!props.validationMessage;
	const validationMessageType = props.validationMessageType;
	const tooltiptype = props.tooltipType || types.TOOLTIP_INFO;
	const value = props.value ? props.value : "";
	const sizeClassName = props.size ? "o-col-" + props.size : "o-col-12";
	const label = props.label + (props.optional ? " (Optioneel)" : "");
	const validation = props.validationMessage ? <ValidationMessage message={props.validationMessage} type={validationMessageType} /> : null;
	const maxLength = props.maxLength ? props.maxLength : "";
	const id = generateGuid();

	const differsFromOriginal = props.originalValue !== undefined ? (props.originalValue || "") !== (props.value || "") : false;
	const revertable = (props.disabled !== true && props.disabled !== 'true') && differsFromOriginal && !props.hideRevert;

	let info = props.tooltip ?
		<Tooltip isInput text={props.tooltip} tooltipType={tooltiptype} /> :
		((props.markChange && differsFromOriginal) ? <Tooltip isInput text={`Originele waarde: ${props.originalValue ? props.originalValue : 'leeg'}`} tooltipType={tooltiptype} /> : null);

	const inputClassName = classnames({
		"c-input__field": true,
		"yellowBackground": props.markChange && differsFromOriginal
	});
	const labelClassName = classnames({
		"c-input__label": true,
		"has-value": hasValue
	});

	const containerClassName = classnames({
		"c-input": true,
		"has-value": hasValue,
		"error": hasValidationMessage,
		"warning": hasValidationMessage && validationMessageType === types.ValidationMessageTypes.WARNING,
		"disabled": props.disabled
	});

	const textArea = (<Textarea
		id={id}
		minRows={props.height}
		value={value}
		disabled={props.disabled}
		onChange={props.onChange}
		className={inputClassName}
		name={props.name}
		maxLength={maxLength}
		autoFocus={props.hasFocus}
	/>);

	return (
		<div className={sizeClassName}>
			<div className={containerClassName}>
				{textArea}
				<label
					className={labelClassName}
					htmlFor={id}>
					{label}
				</label>
				{info}
				{!revertable || <Revert
					onChange={props.onChange}
					name={props.name}
					originalValue={props.originalValue} />}
			</div>
			{validation}
		</div>
	);
};

TextAreaInput.defaultProps = {
	maxFileLimit: 0,
	markChange: false
};

TextAreaInput.propTypes = {
	name: PropTypes.string.isRequired,
	label: PropTypes.string.isRequired,
	onChange: PropTypes.func.isRequired,
	value: PropTypes.string,
	originalValue: PropTypes.string,
	markChange: PropTypes.bool,
	maxLength: PropTypes.number,
	tooltip: PropTypes.string,
	tooltipType: PropTypes.string,
	validationMessage: PropTypes.string,
	validationMessageType: PropTypes.string,
	disabled: PropTypes.bool,
	size: PropTypes.number,
	optional: PropTypes.bool,
	height: PropTypes.number,
	hideRevert: PropTypes.bool,
	hasFocus: PropTypes.bool,
	textarea: PropTypes.node
};

export default TextAreaInput;
